import React, { useState, useEffect } from "react";
import MmvOptionsModal from "@components/mmvOptionsModal";
import SkeletonCard from "@components/skeletonCard";
import { useGetVariants } from "../mmvContainer/useGetMmvData";
import CloneChildren from "@components/children";
import { useVariantState, useGetRegistrationYears } from "./useVariantState";
import { sampleAnalytics, monthToNumber } from "@utils/index";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { setPayloadData } from "@store/slices/globalState";
import { setAnalytics } from "@actions/setAnalyticsData";

const monthMap = {
  Jan: 1,
  Feb: 2,
  Mar: 3,
  Apr: 4,
  May: 5,
  Jun: 6,
  Jul: 7,
  Aug: 8,
  Sep: 9,
  Oct: 10,
  Nov: 11,
  Dec: 12
} as const;

type MonthKey = keyof typeof monthMap;

const SAMPLE_CONFIG = [
  {
    id: 0,
    title: "Which variant do you drive?",
    query: "variant",
    showSearchInput: false,
    isOptional: false
  },
  {
    id: 1,
    title: "When did you register your vehicle?",
    query: "registration_year",
    showSearchInput: false,
    isOptional: false
  }
];

interface EditVariantContainerProps {
  children: React.ReactNode;
  model_id: number;
  initial_variant: string;
  initial_fuel_type: string;
  initial_reg_year?: string;
  initial_reg_month?: string;
  [key: string]: any;
}

const EditVariantContainer: React.FC<EditVariantContainerProps> = (props) => {
  const {
    children,
    initial_variant,
    initial_fuel_type,
    ...otherProps
  } = props;

  const router = useRouter();
  const { proposal_ekey } = router.query;
  
  const storeData = useSelector((state: any) => state.globalState?.payloadData || {});
  const dispatch = useDispatch();
  
  useEffect(() => {
    console.log("Raw props:", props);
    console.log("Props model_id:", props.model_id);
    console.log("Props model_id type:", typeof props.model_id);
  }, [props]);

  const [showMmvModal, setShowMmvModal] = useState<boolean>(false);
  const [currentActiveStepId, setCurrentActiveStepId] = useState<number>(0);
  
  const validModelId = props.model_id ? Number(props.model_id) : null;
  
  const {
    currentStateForVariant,
    currentStateForFuelType,
    setCurrentStateForVariant,
    setCurrentStateForFuelType,
    handleVariantClick
  } = useVariantState({
    initial_variant,
    initial_fuel_type
  });

  const { variantdata, isVariantLoading } = useGetVariants(validModelId);

  const getIndexByQuery = (query: string) => {
    const index = SAMPLE_CONFIG.findIndex((item) => item?.query === query);
    return index !== -1 ? index : 0;
  };

  const handleInputClick = (query: string) => {
    console.log("handleInputClick called with:", query);
    if (query === "variant" || query === "fuel_type") {
      const currentIdOfModal = getIndexByQuery(query === "fuel_type" ? "variant" : query);
      console.log("Setting currentActiveStepId:", currentIdOfModal);
      setCurrentActiveStepId(currentIdOfModal);
      setShowMmvModal(true);
      sampleAnalytics("view", "view_modal", `view_modal_select_${query}_modal`);
    }
  };


  useEffect(() => {
    if (currentStateForVariant && currentActiveStepId === 0) {
      setTimeout(() => {
        setCurrentActiveStepId(1);
      }, 300);
    }
  }, [currentStateForVariant]);

  const sharedState = {
    variant: currentStateForVariant?.variant_name,
    fuel_type: currentStateForFuelType
  };

  const config = [
    {
      ...SAMPLE_CONFIG[0],
      data: variantdata || [],
      selectedState: { currentStateForFuelType, currentStateForVariant },
      setSelectedState: handleVariantClick
    }
  ];

  useEffect(() => {
    console.log("Modal visibility:", showMmvModal);
    console.log("Variant data:", variantdata);
    console.log("Valid Model ID:", validModelId);
  });

  return !isVariantLoading ? (
    <div className="container">
      <CloneChildren
        styles={{
          display: "flex",
          width: "100%",
          gap: "2rem",
          flexDirection: "column"
        }}
        mStyles={{
          gap: "2rem"
        }}
        children={children}
        props={{
          handleInputClick,
          inputState: sharedState,
          ...otherProps
        }}
      />
      
      {showMmvModal && (
        <MmvOptionsModal
          showModal={showMmvModal}
          setShowModal={setShowMmvModal}
          queryType={SAMPLE_CONFIG[currentActiveStepId].query}
          handleClickedVariant={setCurrentStateForVariant}
          handleClickedFuelType={setCurrentStateForFuelType}
          handleClickedMake={() => {}}
          handleClickedModel={() => {}}
          handleClickedRegYear = {()=> {}}
          config={config}
          currentId={currentActiveStepId}
        />
      )}

      <style jsx>{`
        .container {
          width: 100%;
        }
      `}</style>
    </div>
  ) : (
    <SkeletonCard />
  );
};

export default EditVariantContainer; 